import styled from 'styled-components';

const MyCarsContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 1060px;
  width: 100%;
`;

const Title = styled.h2`
  ${(props) => props.theme.font.heading.v400};
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 30px;
  margin: 0;
`;

const VehicleCardWrapper = styled.div`
  align-content: center;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: center;
  padding: 25px;
  padding-bottom: 10px;
  box-shadow: 0px 2px 3px rgba(25, 41, 61, 0.13);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-bottom: 30px;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
    padding: 40px;
    padding-bottom: 10px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    max-width: 1060px;
    min-height: 320px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xxl}px) {
    margin: 0;
    margin-bottom: 30px;
  }
`;

const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  margin: 38px 0 0;
  border-bottom-color: transparent;
`;

export { MyCarsContentWrapper, Title, VehicleCardWrapper, HR };
